import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "full-screen",
    style: { "display": "flex", "flex-direction": "column" }
};
const _hoisted_2 = {
    style: { "z-index": "100", "flex-grow": "5", "max-height": "56px", "min-height": "56px", "height": "56px" },
    class: "bg-light"
};
const _hoisted_3 = { style: { "flex-grow": "5" } };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_TestData = _resolveComponent("TestData");
    const _component_Menu = _resolveComponent("Menu");
    const _component_GoldLayout = _resolveComponent("GoldLayout");
    const _component_AllPlugins = _resolveComponent("AllPlugins");
    const _component_DragDropFileLoad = _resolveComponent("DragDropFileLoad");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_TestData),
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Menu, { menuData: _ctx.menuData }, null, 8, ["menuData"])
        ]),
        _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_GoldLayout)
        ]),
        _createVNode(_component_AllPlugins, {
            onOnPluginSetup: _ctx.onPluginSetup,
            softwareCredits: _ctx.softwareCredits,
            contributorCredits: _ctx.contributorCredits,
            loadedPlugins: _ctx.loadedPlugins
        }, null, 8, ["onOnPluginSetup", "softwareCredits", "contributorCredits", "loadedPlugins"]),
        _createVNode(_component_DragDropFileLoad)
    ]));
}
